module.exports = __webpack_public_path__ + "img/img_works05.c5d788ab.jpg";